import User from './user';

export default class loansUser extends User {

  constructor(userId, profile) {
    super(userId, profile);
    this.creditworthiness = null;
  }

}



// WEBPACK FOOTER //
// ./client/app/common/domain/models/loansUser.js